import axios from 'axios'
import store from '@/store'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: '', // 移除baseURL，在请求中显式添加/api前缀
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
// 在发送请求之前做些什么
service.interceptors.request.use(
  config => {
    // 从localStorage中获取token
    const token = localStorage.getItem('jwt-token')
    
    // 如果token存在，则在请求头中添加token
    if (token) {
      config.headers['Authorization'] = `${token}`
    }
    
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
// 对响应数据做点什么
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 根据后端返回的code进行统一处理
    if (typeof res.code !== 'undefined' && res.code === 200) {
      // 直接返回data字段，方便前端组件使用
      return res.data
    } else {
      // 特别处理msg为null的情况
      const errorMessage = res.msg === null ? '服务器返回成功但消息为空' : (res.msg || '请求失败')
      return Promise.reject(new Error(errorMessage))
    }
  },
  error => {
    // 处理token过期等情况
    if (error.response && error.response.status === 401) {
      // 清除登录状态
      store.dispatch('user/logout')
      // 跳转到登录页
      router.push('/login')
    }
    
    return Promise.reject(error)
  }
)

export default service